import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeBE } from "../const";

export const SAFETY_CRF_CODE: {
  SAFETY_CRF_CREATE_INVALID_CRF_DUPLICATED: MvnCodeBE;
  SAFETY_CRF_INVALID_PAYLOAD_MISSING: MvnCodeBE;
  SAFETY_CRF_INVALID_PAYLOAD_URL: MvnCodeBE;
} = {
  SAFETY_CRF_CREATE_INVALID_CRF_DUPLICATED: {
    status: 409,
    ko: "이미 존재하는 Report 입니다. (name: ({name}), type: ({type}), version: ({version}))",
    en: "The report already exists. (name: ({name}), type: ({type}), version: ({version}))",
  },
  SAFETY_CRF_INVALID_PAYLOAD_MISSING: {
    status: 400,
    ko: "CRF Payload 정보가 누락되었습니다.",
    en: "CRF Payload information is missing.",
  },
  SAFETY_CRF_INVALID_PAYLOAD_URL: {
    status: 400,
    ko: "요청하신 CRF payload URL 정보가 올바르지 않습니다.",
    en: "Requested CRF payload URL is not valid.",
  },
};

MvnCodeInitiate(SAFETY_CRF_CODE);
